<template>
    <AccountLayout>
        <router-view></router-view>
    </AccountLayout>
</template>

<script setup lang="ts">
import AccountLayout from '@/components/layouts/AccountLayout.vue';
</script>
